import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { LogoInput } from '~/components/LogoInput'
import { authenticationAtom } from '~/modules/authentication/data'
import { PersonalTrainerUser } from '~/modules/authentication/types'
import { useAtom } from '~/observers/jotai'
import { personalHomeRoute } from '~/routes/routes'

import { UpdatePersonalTrainerForm } from './components/updatePersonalTrainerForm'

export const PersonalTrainerProfile: React.FC = () => {
  const navigate = useNavigate()
  const [session] = useAtom(authenticationAtom)
  const personalTrainer = session?.user as PersonalTrainerUser

  const handleSubmitForm = useCallback(() => {
    navigate(personalHomeRoute)
  }, [navigate])

  const handleLogoUploadSuccess = useCallback((logoUrl: string) => {
    console.log('Logo uploaded successfully:', logoUrl)
  }, [])

  return (
    <div className='py-5 w-full overflow-y-auto'>
      <div className='flex flex-col gap-6 max-w-[600px] mx-auto'>
        {/* Logo Upload Section */}
        <div className='bg-white rounded-lg p-6'>
          <h2 className='text-xl font-bold mb-4'>Logo Personalizado</h2>
          <LogoInput
            personalTrainerId={personalTrainer?.id || ''}
            onUploadSuccess={handleLogoUploadSuccess}
          />
        </div>

        {/* Profile Update Form */}
        <div className='bg-white rounded-lg p-6'>
          <h2 className='text-xl font-bold mb-3'>Atualizar Perfil</h2>
          <UpdatePersonalTrainerForm onSubmit={handleSubmitForm} />
        </div>
      </div>
    </div>
  )
}
